export function legacyStockDirectionLabel(direction) {
  if (direction === 1 || direction === '1') return 'Dirección alcista';
  return direction === 0 || direction === '0' ? 'Dirección bajista' : '';
}

// Read-only row status; actions remain in the chart header.
export function legacyStockRowDescription(stock = {}) {
  if (stock.nom === '---') return '';
  return [stock.country, stock.index_valor || stock.exchange, stock.sector]
    .filter(value => value && !/^-+$/.test(String(value))).join(' · ');
}
export function legacyStockMembership(stock = {}, user = {}, workspaces = []) {
  const roles = user.roles || {};
  const visible = stock.nom !== '---';
  const favorite = visible && Array.isArray(stock.folder_name) && stock.folder_name.length > 0;
  const portfolio = !visible || roles[21] || roles[20] ? null :
    stock.open_positions_portfolio_name ? 'open' : stock.waitings_portfolio_name != null ? 'waiting' : null;
  const folders = Array.isArray(stock.folder_name) ? stock.folder_name : [];
  const colors = folders.map(name => {
    const folder = workspaces.find(item => item.name === name);
    return folder && /^#[a-f0-9]{3,8}$/i.test(folder.color) ? folder.color : '#778493';
  }).filter((color, index, list) => list.indexOf(color) === index);
  const paint = colors.length > 1 ? `linear-gradient(to bottom, ${colors.map((color, index) =>
    `${color} ${index * 100 / colors.length}% ${(index + 1) * 100 / colors.length}%`).join(', ')})` : colors[0];
  const labels = [];
  if (favorite) labels.push(`En favoritos: ${folders.join(', ')}`);
  if (portfolio) labels.push(portfolio === 'open' ? 'En cartera: posición abierta' : 'En cartera: en espera');
  return {
    'data-stock-favorite': favorite ? 'true' : null,
    'data-stock-portfolio': portfolio,
    style: favorite ? { '--stock-favorite-mark': paint } : null,
    title: labels.length ? labels.join(' · ') : null,
    'aria-label': [stock.ticker, stock.nom !== '---' ? stock.nom : null, visible ? stock.entry_type_name : null, visible ? legacyStockDirectionLabel(stock.direccio) : null, legacyStockRowDescription(stock), ...labels].filter(Boolean).join(' · ')
  };
}
